import { render, staticRenderFns } from "./declineList.vue?vue&type=template&id=32836274"
import script from "./declineList.vue?vue&type=script&lang=js"
export * from "./declineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports